


export const DisplayContainer = ({prop, val, className} : {prop: string, val: string | number, className?: string}) => <div className={className || ""}><span className="font-bold">{prop}: </span>{val}</div>
